import {Injectable} from "@angular/core";
import {IExportGlossary, IGlossaryEntry, IWordTranslations, ITranslation} from "../../api/data-model";
import {ModalConfig} from "../notification/modal.config";
import {ClientConfiguration} from "../configuration/client.config";

@Injectable()
export class GlossaryService {

    private glossaryEntries:IExportGlossary = {};
    private glossaryOpened: boolean = false;

    constructor(private modalConfig: ModalConfig,
                private config: ClientConfiguration) {}

    public injectEntries(entries: IExportGlossary): void {
        this.glossaryEntries = entries;
    }

    public getEntry(id): IGlossaryEntry {
        if ((!this.glossaryEntries || Object.keys(this.glossaryEntries).length === 0) && !this.config.isSuperUserMode) {
            this.modalConfig.openMessageModal("selection_load_error");
        }
        return this.glossaryEntries ? this.glossaryEntries[id] : null;
    }

    public getTranslation(language: string, translations: IWordTranslations, glossaryId: string): ITranslation {
        let translationId:string = translations[language];
        let translation:ITranslation = null;
        if (this.getEntry(glossaryId)) {
            translation = this.getEntry(glossaryId).translations.find((t: ITranslation) => {
                return (t.id === translationId);
            });
        }
        return translation;
    }

    public getTextAudio(entry: IGlossaryEntry): string {
        let textAudio = "";
        if (entry) {
            textAudio = entry.syllables ? entry.syllables.audio : entry.normalAudio;
        }
        return textAudio;
    }

    public setGlossaryOpened(glossaryOpened: boolean): void {
        this.glossaryOpened = glossaryOpened;
    }

    public isGlossaryOpened(): boolean {
        return this.glossaryOpened;
    }

}
